function Camnang() {
    return (
        <h1>Camnang</h1>
    )
}

export default Camnang;